import { apiClient } from '@/shared/api';
import {
  handleRequest,
  type RequestHandlerOptions,
} from '@/shared/api/apiWrapper';
import type {
  ChangePasswordRequestDto,
  ChangePasswordMfaRequiredResponseDto,
} from '../model';
import type { Session } from '@/entities/session';
import { normalizeIdentityTypesInResponse } from '@/entities/mfa-identity/lib/normalizeIdentityType';

const changePassword = async (
  args: ChangePasswordRequestDto,
  options?: RequestHandlerOptions
): Promise<Session | ChangePasswordMfaRequiredResponseDto> => {
  const request = () => apiClient.post('/security/password/change', args);

  const response = await handleRequest<
    Session | ChangePasswordMfaRequiredResponseDto
  >(request, options);

  return normalizeIdentityTypesInResponse(response.data);
};

export { changePassword };
